import React, { useEffect } from "react"; 
import { Link } from 'react-router-dom';
import axios from 'axios'; 
// react plugin for creating charts
// @mui/material
import { useTheme } from "@mui/material/styles";
import Icon from "@mui/material/Icon";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {Box, Tooltip, Fab, Typography, CardContent, Accordion, AccordionSummary, AccordionDetails} from "@mui/material";

// core components
import GridItem from "../../components/Grid/GridItem.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import Card from "../../components/Card/Card.jsx";
import CardHeader from "../../components/Card/CardHeader.jsx";
import CardBody from "../../components/Card/CardBody";
import CardFooter from "../../components/Card/CardFooter.jsx";
import { baseUrl } from '../../components/shared/baseUrl';
import { mongoUrl } from '../../components/shared/mongoUrl';
import cimage from '/assets/images/cimage.jpg'
import {useSelector} from 'react-redux';
import Skeleton from "@mui/material/Skeleton"
import styles from "../../components/assets/jss/material-dashboard-react/views/dashboardStyle.js";


const datepartial = (date) =>{
            
  var st = new Date(date).toString();
  return(
      st.substring(0, 15)
  );
}

const styles1 = (theme) =>({
    cardCategoryWhite: {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    cardTitleWhite: {
      color: "#FFFFFF",
      marginTop: "0px",
      minHeight: "auto",
      fontWeight: "300",
      fontFamily:"'Oswald'",
      marginBottom: "3px",
      textDecoration: "none",
      textAlign:'center'
    },
    fontOswald:{
      fontFamily:"Oswald"
    },
    fontLato:{
        fontFamily:"Lato"
      },
    modal: {
      //display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position:'absolute',
      top:'20%',
      left:'10%',
      overflowY:'scroll',
      height:'100%',
      display:'block'
    },
    modal1:{
      position: 'relative',
      maxWidth: '700px',
      margin : '0 auto',
      padding: '10px 10px 10px 10px',
      background: "rgba(0,0,0,0.5)",
      backgroundColor: 'white',
      borderRadius:'10 px',
      textAlign:'center',
      zIndex: 10
  
    }
  });

function RenderClassItem({ clas }){
  const theme = useTheme()
  const classes =styles(theme);


  return(
        <Link to={`/student/dashboard/viewsession/${clas._id}`}>
          <Card sx={{backgroundColor:'#fffab4'}}>
            <CardContent>
              {clas.image.substring(0,6)!=='assets'?
              <img alt={`${clas.title}`} className="card-img-top" src={mongoUrl+clas.image} />
              :<img alt={`${clas.title}`} className="card-img-top" src={baseUrl+clas.image} />}
            </CardContent>
            <CardBody>
              <h4 style={classes.cardTitle}>{clas.title}</h4>
              <p style={classes.cardCategory}>
                
                Created: {datepartial(clas.Created)}  
                | Active: true
              </p>
            </CardBody>
            {/* <CardFooter chart>
              <div style={classes.stats}>
                <AccessTime /> viewed 4 minutes ago
              </div>
            </CardFooter> */}
          </Card>
           </Link>
        );

}

export default function StudentDashboard() {
  const theme = useTheme()
  const classes = styles(theme);
  const classes1 = styles1(theme)
  const [classe, setclasse] = React.useState([]);
  const [profile, setprofile] = React.useState('');
  const [loading, setloading] = React.useState(true);
  const user = useSelector(state => state.user)
  const [expanded1, setExpanded1] = React.useState('panel1');

  useEffect(() => {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    const loadData=()=>{
      const config = {
        headers: { Authorization: `Bearer ${user.token}` }
    };
    //console.log(user.token)
   


    axios.get(`${baseUrl}users/${user.id}`,config, { cancelToken: source.token })
    .then((response) => {
      const dat = response.data;
      var em = dat.username;
      var nam = dat.fname+' '+dat.lname
      //setemail(dat.username)
      axios.get(`${baseUrl}class`, { cancelToken: source.token })
      .then((response) => {
      const dat = Array.from(response.data)
      console.log(dat)
          
      setclasse(dat)  ////Code to set class when only  one class is created

      axios.get(`${baseUrl}pyinterpreter/profile`)
      .then((response) => {
        ///console.log(response.data)
        var countexperiment=0
          var countcontrol=0
          var impuser=false
        response.data.map((txt,index)=>{
          console.log(txt.type)
          if(txt.userName=='Rohan Kumar Jha'){
            impuser=true
          }
          if(typeof(txt.type)!='undefined' && txt.type=='experiment' && impuser==false){
            countexperiment++
          }
          if(typeof(txt.type)!='undefined' && txt.type=='control' && impuser==false){
            countcontrol++
          }
          
        })
        console.log('count of experiment '+countexperiment)
        console.log('count of control '+countcontrol)

        var newtype='experiment'
          // if(Number(countexperiment) < Number(countcontrol)){
          //   newtype='experiment'
          // }
          // if(Number(countexperiment)>Number(countcontrol)){
          //   newtype='control'
          // }
          if(impuser==true){
            newtype='experiment'
          }


        const ses = response.data.filter((session) => session.userId === user.email)
        
        if(ses.length==0){
          console.log('creating new user')
        }
        else{
          console.log('Old user')
          console.log(response.data)
          setprofile(response.data)
        }

        setloading(false)

      })
      .catch((error)=>{
        console.log(error);
        });
  
      })
      

  
      })
      .catch((error)=>{
      console.log(error);
      });
    
   
  };
    loadData();

    return() => {source.cancel();
    };
}, []);

//console.log(classe)

  const menu=classe.map((clas) => {
    return (
          <GridItem xs={12} sm={9} md={3} key={clas._id}>
                <RenderClassItem clas={clas} />
          </GridItem>
    );
})

const handleAccordionChange1 = (panel) => (event, isExpanded) => {
        
    setExpanded1(isExpanded ? panel : false);
  };

  return (
    loading!==true?
      <div>  
        <div className="container">
          <div className="px-0 col-lg-8 col-md-10 col-sm-12 mx-auto text-center">
              <h1 style={classes1.fontLato}>
                  Scenario: Water Pollution 
              </h1>
              <h4 style={classes1.fontLato}>
                    Activity List
              </h4>
          </div>
        </div>
     
        {loading===false? 
        <GridContainer>
            <Card>
                <CardHeader color="success">
                    <h4 style={classes1.cardTitleWhite}> Activity1: Collect Alluminium Sheets</h4>
                </CardHeader>
                <CardBody>
                <GridContainer>
                <Accordion expanded={expanded1 === 'panel1'} onChange={handleAccordionChange1('panel1')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                            >
                            <Typography sx={classes.heading}>Problem1 </Typography>
                        </AccordionSummary>
                        <AccordionDetails> 
                    <GridItem xs={12} sm={6} md={12}>
                        <Card sx={{    border: '2px solid grey'}}>
                            <CardHeader color="info">
                                <h4 style={classes1.cardTitleWhite}> Problem1</h4>
                            </CardHeader>
                            <CardBody>
                            <GridContainer>
                                <GridItem xs={12} sm={12} md={6}>
                                <blockquote className="blockquote">
                                    <p>The supplier sends the sheets in truck and workers load the ship into the boat.</p>
                                    <p>You observed that in the first turn only 1 aluminum sheet was loaded. Similarly in the second, third, fourth turn, 2, 3, 4 sheets were loaded consecutively and it continued so on.</p>
                                    <p>You observed that total 60 turns were required to deliver all the sheets.</p>
                                    <p>You want to count the total amount of aluminum sheets delivered to the boat but you cannot count manually as it will take a lot of time.</p> 
                                    <p>You need to find a method to calculate the sum quickly. Design an algorithm to calculate the sum of numbers from 1 to n=60.Your objective is defined as follows:</p>
                                
                                </blockquote>
                                </GridItem>
                                <GridItem xs={12} sm={12} md={6}>
                                <img alt='sumfrom1ton' className="card-img-top"  src={baseUrl+'assets/images/act1-sumfrom1ton.PNG'} />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={12}>
                                <blockquote className="blockquote">
                                    <p>Number of aluminium sheets = 1 + 2 + 3 + ... + 60</p><p><b>Input: </b>n=60</p>
                                    <p><b>Output: </b>Total number of aluminium sheet=1830</p><p>
                                    <b>Objective: </b> Write an algorithm to find the sum of consecutive numbers from 1 to n i.e., 1+2+3+...+n, where n=60.</p>
                                </blockquote>
                                </GridItem>
                            </GridContainer>
                            </CardBody>
                        </Card>
                    </GridItem>
                    </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded1 === 'panel2'} onChange={handleAccordionChange1('panel2')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                            >
                            <Typography sx={classes.heading}>Problem2 </Typography>
                        </AccordionSummary>
                        <AccordionDetails> 
                            <GridItem xs={12} sm={6} md={12}>
                                <Card sx={{    border: '2px solid grey'}}>
                                    <CardHeader color="info">
                                        <h4 style={classes1.cardTitleWhite}> Problem2</h4>
                                    </CardHeader>
                                    <CardBody>
                                    <GridContainer>
                                        <GridItem xs={12} sm={12} md={6}>
                                        <blockquote className="blockquote">
                                            <p>The supplier has started the delivery of aluminium sheets.</p>
                                            <p> After delivering the aluminium sheets, the vendor sent you a note which says: 'Total 60 alluminium sheets are delivered, where One set of aluminium sheet contains two plates with different shape.</p>
                                            <p>The first plate is a triangle with sides 20 cm, 16 cm, and 12 cm. 
                                            The second plate is a square having side equal to semi perimeter of the previous triangle'.</p> 
                                            <p>Your task is to find the area of one set of aluminium sheet delivered. Your objective is defined as follows:</p>
                                            <p>Area of one set of aluminium sheet = Area of triangle shaped sheet + Area of square shaped sheet </p>
                                        
                                        </blockquote>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={6}>
                                        <img alt='areaof1sheet' className="card-img-top"  src={baseUrl+'assets/images/act1-areaof1sheet.PNG'} />
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={12}>
                                        <blockquote className="blockquote">
                                            <p><strong>Input: </strong>side1=20,side2=16,side3=12</p>
                                            <p><strong>Output: </strong>Total area of aluminium sheet=672 </p><p>
                                            <strong>Objective: </strong> Write an algorithm to find the total area of 1 set of aluminium sheets delivered where each set of aluminium sheet contains two plates, one plate having triangle shaped with sides 20 cm, 16 cm, and 12cm, while other plate is square shaped with side equal to semi perimeter of triangle.</p>
                                        </blockquote>
                                        </GridItem>
                                    </GridContainer>
                                    </CardBody>
                                </Card>
                            </GridItem>
                    </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded1 === 'panel3'} onChange={handleAccordionChange1('panel3')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                            >
                            <Typography sx={classes.heading}>Problem3 </Typography>
                        </AccordionSummary>
                        <AccordionDetails> 
                    <GridItem xs={12} sm={6} md={12}>
                        <Card sx={{    border: '2px solid grey'}}>
                            <CardHeader color="info">
                                <h4 style={classes1.cardTitleWhite}> Problem3</h4>
                            </CardHeader>
                            <CardBody>
                            <GridContainer>
                                <GridItem xs={12} sm={12} md={6}>
                                <blockquote className="blockquote">
                                    <p>The supplier has agreed to send the sheets in multiple turns direct from the warehouse. </p>
                                    <p>You observed that in the first turn 1 aluminum sheet is delivered and in second term 1 aluminum sheet is delivered. </p>
                                    <p>In the third turn 2(1+1) sheets were delivered, fourth term 3=(1+2), similarly in the fifth term 5(2+3) sheets were delivered and it continued so on.</p> 
                                    <p>You can see that after 3rd turn the count of aluminum sheet is sum of aluminum sheets delivered in last two turns.</p> 
                                    <p>To summarize, the current term is sum of last two terms. These terms are also called Fibonacci sequence of numbers.</p> 
                                    <p>First Fibonacci number=1, second Fibonacci number=1, Third Fibonacci number=2, Fourth Fibonacci number=3 and so on.</p> 
                                    <p>You observed that total 10 turns were required to deliver all the sheets. You want to count the total amount of aluminum sheets delivered to the boat but you cannot count manually as it will take a lot of time. </p> 
                                    <p>You need to find a method to calculate the sum quickly. Design an algorithm to calculate the sum of numbers from 1 to n=10. Your objective is defined as follows:</p>
                                </blockquote>
                                </GridItem>
                                <GridItem xs={12} sm={12} md={6}>
                                <img alt='fibosum1ton' className="card-img-top"  src={baseUrl+'assets/images/act1-fibosum1ton.PNG'} />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={12}>
                                <blockquote className="blockquote">
                                    <p>Number of aluminium sheets = 1+1+2+3+5... +upto 10th term</p><p><strong>Input: </strong>10</p><p><strong>Output: </strong>Total number of aluminium sheet=143</p><p><strong>Objective: </strong> Write an algorithm to find the sum of n=10 fibonacci numbers starting from 1+1+2+3+5+..upto 10 terms.</p>
                                </blockquote>
                                </GridItem>
                            </GridContainer> 
                            </CardBody>
                        </Card>
                    </GridItem>
                    </AccordionDetails>
                    </Accordion>
                </GridContainer>
                
                </CardBody>
            </Card>
            
            <Card>
                <CardHeader color="success">
                    <h4 style={classes1.cardTitleWhite}> Activity2: Password to start boat</h4>
                </CardHeader>
                <CardBody>
                <GridContainer>
                    <Accordion expanded={expanded1 === 'panel4'} onChange={handleAccordionChange1('panel4')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                            >
                            <Typography sx={classes.heading}>Problem1 </Typography>
                        </AccordionSummary>
                        <AccordionDetails> 
                            <GridItem xs={12} sm={6} md={12}>
                                <Card sx={{    border: '2px solid grey'}}>
                                    <CardHeader color="info">
                                        <h4 style={classes1.cardTitleWhite}> Problem1</h4>
                                    </CardHeader>
                                    <CardBody>
                                    <GridContainer>  
                                            <GridItem xs={12} sm={12} md={6}> 
                                                <blockquote className="blockquote">
                                                    <p> You started searching for hints nearby to start the boat. After multiple searches you found a note nearby steering wheel.</p> 
                                                    <p> The note says “The password is a four digit number. The password can be calculated from a two digit number. Given two digit number 29, Password to start the boat is the largest four digit number divisible by 29.” </p>
                                                    <p> Your task is to identify the 4 digit passcode to unlock the steering wheel and start the boat to continue the mission. </p> 
                                                    <p> You cannot calculate manually as it may take lot of time, so you decided to write an algorithm to retrieve the password.</p> 
                                                    <p> Your objective is defined as follows: </p>
                                                </blockquote>                             
                                                
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={6}>
                                            <img alt='largest4digitnum' className="card-img-top"  src={baseUrl+'assets/images/act2-LargestFourdigitNum.PNG'} />
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={12}> 
                                                <blockquote className="blockquote">
                                                    <p><strong>Input: </strong>29</p><p><strong>Output: </strong>The 4-digit password is 9976 </p><strong>Objective: </strong> Write an algorithm to find the four digit password which is the largest four digit number divisible by n=29
                                                </blockquote>
                                            </GridItem>
                                    </GridContainer>
                                    </CardBody>
                                </Card>
                            </GridItem>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded1 === 'panel5'} onChange={handleAccordionChange1('panel5')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                            >
                            <Typography sx={classes.heading}>Problem2 </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <GridItem xs={12} sm={6} md={12}>
                                <Card sx={{    border: '2px solid grey'}}>
                                    <CardHeader color="info">
                                        <h4 style={classes1.cardTitleWhite}> Problem2</h4>
                                    </CardHeader>
                                    <CardBody>
                                    <GridContainer>
                                        <GridItem xs={12} sm={12} md={6}>
                                        <blockquote className="blockquote">
                                            <p>You started searching for hints nearby to start the boat. After multiple searches you found a note nearby steering wheel.</p> 
                                            <p>The note says “ The password is a four digit number. The password are two numbers among the set of numbers [12, 17, 24, 27, 29, 37] which adds upto 53.</p>
                                            <p>Find the pair of numbers and retrieve the password”. Find a pair of numbers from the set of number {'{'}12, 17, 24, 27, 29, 37{'}'} having sum 53.</p>
                                            <p> Your task is to identify the 4 digit passcode to unlock the steering wheel and start the boat to continue the mission. You cannot calculate manually as it may take lot of time, so you decided to write an algorithm to retrieve the password. Your objective is defined as follows:</p>
                                        </blockquote>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={6}>
                                        <img alt='sumOfnumArray' className="card-img-top"  src={baseUrl+'assets/images/act2-sumofNumArray.PNG'} />
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={12}>
                                        <blockquote className="blockquote">
                                            <p><strong>Input: </strong>53</p><p><strong>Output: </strong>The 4-digit password: 2429 or 2924 </p><p><strong>Objective: </strong> Given a set of numbers {'{'}12, 17, 24, 27, 29, 37{'}'}. Write an algorithm to find the four digit number consisting of pair of number that adds to n=53</p>
                                        </blockquote>
                                        </GridItem>
                                    </GridContainer>
                                    </CardBody>
                                </Card>
                            </GridItem>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded1 === 'panel6'} onChange={handleAccordionChange1('panel6')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                            >
                            <Typography sx={classes.heading}>Problem3 </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <GridItem xs={12} sm={6} md={12}>
                                <Card sx={{    border: '2px solid grey'}}>
                                    <CardHeader color="info">
                                        <h4 style={classes1.cardTitleWhite}> Problem3</h4>
                                    </CardHeader>
                                    <CardBody>
                                        <GridContainer>
                                            <GridItem xs={12} sm={12} md={6}>
                                            <blockquote className="blockquote">
                                                <p> You started searching for hints nearby to start the boat. After multiple searches you found a note nearby steering wheel.</p> 
                                                <p> The note says “Password can be retrieved by adding 40 consecutive odd numbers starting from 1 to 79.</p> 
                                                <p> The odd numbers are 1st= 1, 2nd term= 3, 3rd term=5, 4th term= 7 and continuing upto 40 terms. The 40th term will be 79. Add 40 terms to find the password”. </p>
                                                <p>Your task is to identify the 4 digit passcode to unlock the steering wheel and start the boat to continue the mission.</p> 
                                                <p> You cannot calculate manually as it may take lot of time, so you decided to write an algorithm to retrieve the password. Your objective is defined as follows: </p>
                                            </blockquote>
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={6}>
                                            <img alt='oddSum1ton' className="card-img-top"  src={baseUrl+'assets/images/act2-oddsum1ton.PNG'} />
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={12}>
                                            <blockquote className="blockquote">
                                                <p><strong>Input: </strong>40</p><p><strong>Output: </strong>The 4-digit password is 1600 </p><p><strong>Objective: </strong> Write an algorithm to find sum of first 40 odd numbers such as 1+3+5+7+…+n=79(40th term).</p>
                                            </blockquote>
                                            </GridItem>
                                        </GridContainer>
                                    </CardBody>
                                </Card>
                            </GridItem>
                        </AccordionDetails>
                    </Accordion>
                </GridContainer>
                </CardBody>
            </Card>
            <Card>
                <CardHeader color="success">
                    <h4 style={classes1.cardTitleWhite}> Activity3: Collect Resource Bags</h4>
                </CardHeader>
                <CardBody>
                <GridContainer>
                <Accordion expanded={expanded1 === 'panel7'} onChange={handleAccordionChange1('panel7')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                            >
                            <Typography sx={classes.heading}>Problem1 </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                    <GridItem xs={12} sm={6} md={12}>
                        <Card sx={{    border: '2px solid grey'}}>
                            <CardHeader color="info">
                                <h4 style={classes1.cardTitleWhite}> Problem1</h4>
                            </CardHeader>
                            <CardBody>
                                <GridContainer>
                                    <GridItem xs={12} sm={12} md={6}>
                                    <blockquote className="blockquote">
                                        <p> You have to collect resource bags from the islands. You have found a list which contains details of all the resource bags you need to pick up from islands.</p> 
                                        <p> From the first island you have to collect 3 bags. From the second island you need to collect 3+2=5 bags.</p> 
                                        <p> Next from third island you need to collect  7=5+2 bags. From fourth island next  you collected 9=7+2 bags and so on.</p> 
                                        <p> You observed that there are total 7 islands in total following the same pattern. Also the difference between bag in one island with previous island is 2 which is also called the common difference.</p> 
                                        <p> You have to find the total bags collected from the last island i.e., 7th island. </p>  
                                        <p> Hence, your task is to find the 7th term of sequence where the terms are in arithmetic sequence i.e., 1st term=3, 2nd term is 3+2=5, where 2 is the common difference. Similarly, the 3rd term=3+2+2=7.</p>
                                        <p> You cannot calculate manually as it may take a lot of time, so you decided to write an algorithm to calculate the number of bags. Your objective is defined as follows:</p>
                                        
                                    </blockquote>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={6}>
                                    <img alt='Activity1Medium' className="card-img-top"  src={baseUrl+'assets/images/act3-nthTermAP.PNG'} />
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={12}>
                                    <blockquote className="blockquote">
                                        <p><strong>Input: </strong>Given first number=3, common difference=2, nth term=7</p><p><strong>Output: </strong>Total bags collected=15</p><p>
                                        <strong>Objective: </strong> Write an algorithm to find the 7th term (n=7) of an arithmetic sequence 3, 5, 7, 9, … , where first term=3 and common difference between terms=2.</p>
                                    </blockquote>
                                    </GridItem>
                                </GridContainer>
                            </CardBody>
                        </Card>
                    </GridItem>
                    </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded1 === 'panel8'} onChange={handleAccordionChange1('panel8')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                            >
                            <Typography sx={classes.heading}>Problem2 </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <GridItem xs={12} sm={6} md={12}>
                                <Card sx={{    border: '2px solid grey'}}>
                                    <CardHeader color="info">
                                        <h4 style={classes1.cardTitleWhite}> Problem2</h4>
                                    </CardHeader>
                                    <CardBody>
                                    <GridContainer>
                                        <GridItem xs={12} sm={12} md={6}>
                                        <blockquote className="blockquote">
                                            <p> You have to collect resource bags from one island. You have arrived in the island and waiting to collect bags of resources. </p>
                                            <p> The island contains 4 bags of resources consisting of 12 units, 8 units, 16 units, and 5 units of resource. </p>
                                            <p> The bags are torn with multiple leaks, and thus needs to be stored in a single bag.</p> 
                                            <p> Now, combining two bags of resources are little bit tricky. It is found that combining two bags with x units and y units takes (x+y) minutes cost to complete. </p>
                                            <p> For example, combining first bag with 12 units and second bag with 8 units costs 12+8=20 minutes cost. Now the new bag contains 20 units of bag including 16 units and 5 units. </p>
                                            <p> Further, you can combine two bags to calculate the time cost needed and so on until all bags are combined into single bag. </p> 
                                            <p> Please note that, the total cost depends on how you select first two bags and then next bags accordingly. </p>
                                        
                                        </blockquote>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={6}>
                                        <img alt='Activity1Medium' className="card-img-top"  src={baseUrl+'assets/images/act3-minTimeCost.PNG'} />
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={12}>
                                        <blockquote className="blockquote">
                                            <p> Your task is to find the minimum time cost needed to combine all resource bags into single bag. You cannot calculate manually as it may take lot of time, so you decided to write an algorithm to calculate the minimum cost to combine bags. Your objective is defined as follows:</p><p><strong>Input: </strong>: Four bags of resources: Bag1=12, Bag2=8, Bag3=16, Bag4=5 </p>
                                            <p><strong>Output: </strong> Minimum time cost = 79 minutes </p><p><strong>Objective: </strong> Write an algorithm to find minimum cost time to combine four bags of resources having 12,8,16,5 units of resources. Adding two bags of resources x and y will cost x+y minutes of time to complete and will be combined to a new bag by removing previous two bags.</p>
                                        </blockquote>
                                        </GridItem>
                                    </GridContainer>
                                    </CardBody>
                                </Card>
                            </GridItem>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded1 === 'panel9'} onChange={handleAccordionChange1('panel9')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                            >
                            <Typography sx={classes.heading}>Problem3 </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <GridItem xs={12} sm={6} md={12}>
                                <Card sx={{    border: '2px solid grey'}}>
                                    <CardHeader color="info">
                                        <h4 style={classes1.cardTitleWhite}> Problem3</h4>
                                    </CardHeader>
                                    <CardBody>
                                    <GridContainer>
                                        <GridItem xs={12} sm={12} md={6}>
                                        <blockquote className="blockquote">
                                            <p> You have to collect resource bags from the islands. There are total 5 islands in the way but you can visit only 2 islands. </p>
                                            <p> You want to identify the total number of ways you can visit any two islands out of 5 islands. </p>
                                            <p> Thus, we have to select all possible 2 islands out of 5 islands. Selecting all possible 2 islands out of 5 islands can be done by calculating permutation of 2 from 5 islands.</p> 
                                            <p> All possible permutations of 2 out of 5 is written as Permutation(5, 2).</p> 
                                            <p> Permutation(m,n) can be written as Factorial(m)/Factorial(m-n). Where Factorial(m)=m*(m-1)*(m-2)*…upto 1.</p> 
                                            <p> For example, Factorial(3)=3*2*1=6, Factorial(2)=2*1=2, Permutation(3,2)=Factorial(3)/Factorial(2)=3.</p>
                                        </blockquote>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={6}>
                                        <img alt='Activity1Medium' className="card-img-top" src={baseUrl+'assets/images/act3-select2outof5.PNG'} />
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={12}>
                                        <blockquote className="blockquote">
                                            <p>Hence, your task is to find the permutation of 2 out of 5 i.e., permutation(5,2). You cannot calculate manually as it may take lot of time, so you decided to write an algorithm to calculate the number of ways to visit 2 islands. Your objective is defined as follows:</p><p>Number of ways = permutation(5,2)</p><p><strong>Input: </strong>Given n=5, k=2</p><p><strong>Output: </strong>permutation of (n=5,k=2)=20 </p><p><strong>Objective: </strong> Given the 5 islands with resource bags and you want to visit only 2 islands. Design an algorithm to find all possible ways you can visit 2 islands out of 5 islands by calculating permutation of (5,2).</p>
                                        </blockquote>
                                        </GridItem>
                                    </GridContainer>
                                    </CardBody>
                                </Card>
                            </GridItem>
                        </AccordionDetails>
                    </Accordion>
                </GridContainer>
                
                </CardBody>
            </Card>
            <Card>
                <CardHeader color="success">
                    <h4 style={classes1.cardTitleWhite}> Activity4: Repair broken bridge</h4>
                </CardHeader>
                <CardBody>
                <GridContainer>
                    <Accordion expanded={expanded1 === 'panel10'} onChange={handleAccordionChange1('panel10')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                            >
                            <Typography sx={classes.heading}>Problem1 </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <GridItem xs={12} sm={6} md={12}>
                                <Card sx={{    border: '2px solid grey'}}>
                                    <CardHeader color="info">
                                        <h4 style={classes1.cardTitleWhite}> Problem1</h4>
                                    </CardHeader>
                                    <CardBody>
                                    <GridContainer>
                                        <GridItem xs={12} sm={12} md={6}>
                                        <blockquote className="blockquote">
                                        <p> One of your team mate observed the bridge and said that we need logs in form of right circular cylinder having radius 4 cm and height 100cm.</p>
                                        <p> Your team started searching nearby for trees with height 100cm to cut and extract logs. Finally, you found a large right circular tree with radius 21cm and height 100cm. </p> 
                                        <p> You want to extract maximum number of logs from the tree of same size (i.e., base radius 4 cm and same height as tree=100cm) in order to reduce the waste of logs. </p> 
                                        <p> Your task is to find the maximum number of logs of base radius 4 cm can be extracted from a right circular cylinder tree with base radius 21cm. </p>
                                        <p> You cannot calculate manually as it may take lot of time, so you decided to write an algorithm to find the maximum number of logs extracted from tree.</p> 
                                            <p>Your objective is defined as follows:</p>
                                            <p>Number of logs=maximum logs of radius 4 units extracted from tree with radius n=21 units</p>
                                        </blockquote>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={6}>
                                        <img alt='Activity1Medium' className="card-img-top"  src={baseUrl+'assets/images/act4-countLogs.PNG'} />
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={12}>
                                        <blockquote className="blockquote">
                                            <p><strong>Input: </strong>log radius(n)=4</p><p><strong>Output: </strong>Total logs required=27</p><p><strong>Objective: </strong>  Write an algorithm to calculate the maximum number of right circular cylindrical logs of base radius 4 cm to be extracted from a right circular cylindrical tree with radius 21 cm with same height(100 cm) as logs.</p>
                                        </blockquote>
                                        </GridItem>
                                    </GridContainer>
                                    </CardBody>
                                </Card>
                            </GridItem>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded1 === 'panel11'} onChange={handleAccordionChange1('panel11')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                            >
                            <Typography sx={classes.heading}>Problem2 </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <GridItem xs={12} sm={6} md={12}>
                                <Card sx={{    border: '2px solid grey'}}>
                                    <CardHeader color="info">
                                        <h4 style={classes1.cardTitleWhite}> Problem2</h4>
                                    </CardHeader>
                                    <CardBody>
                                    <GridContainer>
                                        <GridItem xs={12} sm={12} md={6}>
                                        <blockquote className="blockquote">
                                            <p> One of your team mate observed the bridge and said that we need logs in form of right circular cylinder having radius 4 unit and height 100 units. </p>
                                            <p> Now, your team started searching nearby for trees with height 100 units to cut and extract logs. You finally found three large right circular trees having radius 21, 22 and 24 and height 100 units.</p> 
                                            <p> You don't want to cut too many trees in order to reduce the waste of logs due to environment conservation. Thus, you decided to cut only one tree producing less wastage of logs after extracting maximum number of logs from the trees. </p>
                                            <p> Your task is to identify the radius of tree with minimum volume of wood wasted after extracting logs of radius 4 unit and height 100 unit.You cannot calculate manually as it may take lot of time, so you decided to write an algorithm to find the tree producing minimum wastage of wood.</p> 
                                            <p> Your objective is defined as follows:</p>
                                            <p>Required Tree=Tree with minimum logs of radius 4 units extracted among trees with radius 21,22, and 24 units</p> 
                                        </blockquote>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={6}>
                                        <img alt='Activity4 minWasteLogs' className="card-img-top"  src={baseUrl+'assets/images/act4-minWasteLogs.PNG'} />

                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={12}>
                                        <blockquote className="blockquote">
                                            <p><strong>Input: </strong>log radius(n)=4</p>
                                            <p><strong>Output: </strong>Radius of tree with minimum waste logs=24</p>
                                            <p><strong>Objective: </strong>  Write an algorithm to find the minimum of wood wasted among trees with radius 21 unit, 22 unit and 24 unit with height 100 unit after extracting maximum number of logs having radius 4 unit.</p>
                                        </blockquote>
                                        </GridItem>
                                    </GridContainer>
                                    </CardBody>
                                </Card>
                            </GridItem>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded1 === 'panel12'} onChange={handleAccordionChange1('panel12')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                            >
                            <Typography sx={classes.heading}>Problem3 </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <GridItem xs={12} sm={6} md={12}>
                                <Card sx={{    border: '2px solid grey'}}>
                                    <CardHeader color="info">
                                        <h4 style={classes1.cardTitleWhite}> Problem3</h4>
                                    </CardHeader>
                                    <CardBody>
                                    <GridContainer>
                                        <GridItem xs={12} sm={12} md={6}>
                                        <blockquote className="blockquote">
                                        <p> You have surveyed the bridge and identified that 55 logs are needed in order to repair the bridge.</p> 
                                        <p> You have identified 6 trees to collect logs for repairing the bridge.</p> 
                                        <p> First tree yields 12 logs, second log yields 17 logs, third logs yields 24 logs. </p> 
                                        <p> continuing this the set of numbers {'{'}12, 17, 24, 27, 33, 37 {'}'} represents the trees with extracted logs.</p> 
                                        <p> You don't want to cut too many trees due to environment conservation and therefore you decided to cut only 2 trees which can yield logs sufficient enough to repair the bridge.</p> 
                                        <p> Your task is to identify the pair of trees that gives logs closer to 55.You cannot calculate manually as it may take lot of time, so you decided to write an algorithm to find the trees that yield logs closer and sufficient to repair the bridge.</p> 
                                        <p> Your objective is defined as follows:</p><p>Pair of trees with logs = sum of logs closer to 55 logs needed to repair the bridge</p>
                                        </blockquote>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={6}>
                                        <img alt='Activity4sumLogslclosest' className="card-img-top"  src={baseUrl+'assets/images/act4-sumLogsClosest.PNG'} />
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={12}>
                                        <blockquote className="blockquote">
                                            <p><strong>Input: </strong>55</p><p><strong>Output: </strong>A pair of number having sum closest to 55 = 17,37 </p><p><strong>Objective: </strong> Given a set of logs that can be extracted from six trees {'{'}12, 17, 24, 27, 33, 37 {'}'} and a required log count of 55. Write an algorithm to select a pair of trees such that the total sum of logs are closest to 55 required logs. The sum may be more or less but should be closest to the  given number.</p>
                                        </blockquote>
                                        </GridItem>
                                    </GridContainer>
                                    </CardBody>
                                </Card>
                            </GridItem>
                        </AccordionDetails>
                    </Accordion>
                </GridContainer>
                
                </CardBody>
            </Card>
            <Card>
                <CardHeader color="success">
                    <h4 style={classes1.cardTitleWhite}> Activity5: Solve the Puzzle</h4>
                </CardHeader>
                <CardBody>
                <GridContainer>
                <Accordion expanded={expanded1 === 'panel13'} onChange={handleAccordionChange1('panel13')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                            >
                            <Typography sx={classes.heading}>Problem1 </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <GridItem xs={12} sm={6} md={12}>
                                <Card sx={{    border: '2px solid grey'}}>
                                    <CardHeader color="info">
                                        <h4 style={classes1.cardTitleWhite}> Problem1</h4>
                                    </CardHeader>
                                    <CardBody>
                                    <GridContainer>
                                        <GridItem xs={12} sm={12} md={6}>
                                        <blockquote className="blockquote">
                                            <p> The writings on the door describes a puzzle problem as describe below: </p>
                                            <p>Given a sequence AA_BB. A's and B's are displayed in five positions. A's are in position 1 and position 2 and B's are in position 4 and position 5. Position 3 is empty which can be used to move A or B's. 
                                                Swap the positions of A's and B's in minimum number of moves as possible i.e., convert AA_BB to BB_AA. There are two ways to move a piece   
                                            </p>
                                            <p>1. Move left or right to an adjacent empty square </p>
                                            <p>2. Jump over a single adjacent piece into an open space.</p>
                                            <p>
                                            Can you develop the steps to solve the problem in minimum number of operations. The door will open automatically after you identify the minimum steps required to reverse the positions of A and B.
                                            Your objective is defined as follows:</p>
                                            
                                        </blockquote>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={6}>
                                        <img alt='Activity5Medium' className="card-img-top"  src={baseUrl+'assets/images/act5-jumpingPuzzle.PNG'} />
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={12}>
                                        <p>Given a sequence of letters AA_BB</p><p><strong>Input: </strong>AA_BB</p><p><strong>Output: </strong> BB_AA in 7 steps</p>
                                        <p><strong>Objective: </strong> Given a sequence of letters AA_BB. Identify the minimum steps required to convert AA_BB to BB_AA.</p>
                                        </GridItem>
                                    </GridContainer>
                                    </CardBody>
                                </Card>
                            </GridItem>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded1 === 'panel14'} onChange={handleAccordionChange1('panel14')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                            >
                            <Typography sx={classes.heading}>Problem2 </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <GridItem xs={12} sm={6} md={12}>
                                <Card sx={{    border: '2px solid grey'}}>
                                    <CardHeader color="info">
                                        <h4 style={classes1.cardTitleWhite}> Problem2</h4>
                                    </CardHeader>
                                    <CardBody>
                                    <GridContainer>
                                        <GridItem xs={12} sm={12} md={6}>
                                        <blockquote className="blockquote">
                                            <p> The writings on the door describes a puzzle problem as describe below: </p>
                                            <p>Given a geometrical diagram with sides and given angles. 
                                                Find the area of geometrical structure following any version of the same diagram. 
                                            </p>
                                            <p>Given functions    </p>
                                            <p>TriangleArea(s1,s2,s3) ==={'>'} {'{'}return semiper = (s1+s2+s3)/2; root(semiper*(semiper-s1)*(semiper-s2)*(semiper-s3)) {'}'}</p>
                                            <p>EquilateralTriArea(side) ==={'>'} {'{'} return root(3)/4*side*side {'}'}</p>
                                            <p>BaseHeightTriArea(base,height) ==={'>'} {'{'} return 1/2*base*height {'}'}</p>
                                            <p> RectangleArea(side1,side2) ==={'>'} {'{'} return side1*side2 {'}'}</p>
                                            <p>
                                            Can you develop the algorithm to calculate area of given diagram in minimum number of operations.
                                            Your objective is defined as follows:</p>
                                        </blockquote>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={6}>
                                        <img alt='Activity5Easy' className="card-img-top"  src={baseUrl+'assets/images/act5-geometryArea.PNG'} />
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={12}>
                                        <blockquote className="blockquote">
                                            <p>Given functions related to triangle and rectangle</p><p><strong>Input: </strong> Given geometrical diagram </p><p><strong>Output: </strong> Area of diagram=144</p>
                                            <p><strong>Objective: </strong> Identify the minimum operations to calculate area of given diagram.</p>
                                        </blockquote>
                                        </GridItem>
                                    </GridContainer>
                                    </CardBody>
                                </Card>
                            </GridItem>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded1 === 'panel15'} onChange={handleAccordionChange1('panel15')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                            >
                            <Typography sx={classes.heading}>Problem3 </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <GridItem xs={12} sm={6} md={12}>
                                <Card sx={{    border: '2px solid grey'}}>
                                    <CardHeader color="info">
                                        <h4 style={classes1.cardTitleWhite}> Problem3</h4>
                                    </CardHeader>
                                    <CardBody>
                                    <GridContainer>
                                        <GridItem xs={12} sm={12} md={6}>
                                        <blockquote className="blockquote">
                                            <p> The writings on the door describes a puzzle problem as describe below: </p>
                                            <p>There are 3 towers and 3 rings. These rings are of different sizes and stacked upon in an ascending order, i.e. the smaller one sits over the larger one. 
                                                The objective of the problem is to move the entire stack from source rod to destination rod, obeying the following simple rules: 
                                            </p>
                                            <p>1. Only one disk can be moved at a time. </p>
                                            <p>2. Each move consists of taking the upper disk from one of the stacks and placing it on top of another stack i.e. a disk can only be moved if it is the uppermost disk on a stack.</p>
                                            <p>3. No disk may be placed on top of a smaller disk (large disk cannot be on the small disk).</p>
                                            <p>
                                            Can you develop the steps to solve the problem in minimum number of operations. The door will open automatically after you identify the minimum steps required to convert from initial position to final position.
                                            Your objective is defined as follows:</p>
                    
                                        </blockquote>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={6}>
                                        <img alt='Activity5Hard' className="card-img-top"  src={baseUrl+'assets/images/towerOfHanoi.PNG'} />
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={12}>
                                        <blockquote className="blockquote">
                                            <p>Given 3 towers and 3 rings</p><p><strong>Input: </strong> Initial position (see image) </p><p><strong>Output: </strong> Final position (see image)</p>
                                            <p><strong>Objective: </strong> Identify the minimum steps required to convert from Intial to final position.</p>
                                        </blockquote>
                                        </GridItem>
                                    </GridContainer>
                                    </CardBody>
                                </Card>
                            </GridItem>
                        </AccordionDetails>
                    </Accordion>
                </GridContainer>
                
                </CardBody>
            </Card>
            <Card>
                <CardHeader color="success">
                    <h4 style={classes1.cardTitleWhite}> Activity6: Repair the damaged ship</h4>
                </CardHeader>
                <CardBody>
                <GridContainer>
                    <Accordion expanded={expanded1 === 'panel16'} onChange={handleAccordionChange1('panel16')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                            >
                            <Typography sx={classes.heading}>Problem1 </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <GridItem xs={12} sm={6} md={12}>
                                <Card sx={{    border: '2px solid grey'}}>
                                    <CardHeader color="info">
                                        <h4 style={classes1.cardTitleWhite}> Problem1</h4>
                                    </CardHeader>
                                    <CardBody>
                                    <GridContainer>
                                        <GridItem xs={12} sm={12} md={6}>
                                        <blockquote className="blockquote">
                                            <p> The captain gave you a brief idea regarding the overall damage to the ship. Your team is observing the boat and analyzing the cracks(holes) in the ship that needs to be repaired. </p>
                                            <p> After observing the holes, it was found that there are lots of holes that needs to be repaired and is more than the alluminimum sheets present at the accident sight. </p>
                                            <p> Thus, you have to create sheets at the accident site to repair the ship. Fortunately, the ship has a lot of  metallic right circular conical plates of radius 4 units and height 21 units and cylindrical plates of double radius than cone and half height than cone. </p> 
                                            <p> You have a machine that can melt one conical plate and cylindrical plate to form a new cylindrical plate of radius 1 unit. Now, you want to create aluminium sheets by melting the cone and cylinder of given radius and height to new cylindrical plates of height 1 units. </p> 
                                            <p> Your task is to find the radius of cylindrical plate and finally repair the boat. You cannot calculate manually as it may take lot of time, so you decided to write an algorithm to find radius of new cylindrical plate with height 1 units. Your objective is defined as follows: </p>
                                            <p> Given a right circular cone of radius 4 units, height 21 units and right circular cylinder with radius=double of cone radius and height=half of cone height. radius of new Cylinder = radius of cylinder formed by adding cylinder and cone</p><p><strong>Input: </strong>radius=4, height=21</p><p><strong>Output: </strong> radius of cylinder=28 unit</p>
                                        </blockquote>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={6}>
                                        <img alt='Activity1Medium' className="card-img-top"  src={baseUrl+'assets/images/act6-cylindricalPlates.PNG'} />
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={12}>
                                        <blockquote className="blockquote">
                                            <p><strong>Objective: </strong> Given a right circular cone of radius 4 units, height 21 units and right circular cylinder with radius=double of cone radius and height=half of cone height. The cone and right circular cylinder was melted to form a new cylindrical plate of height 1 units. Write an algorithm to find the radius of new cylindrical metal plate.</p>
                                        </blockquote>
                                        </GridItem>
                                    </GridContainer>
                                    </CardBody>
                                </Card>
                            </GridItem>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded1 === 'panel17'} onChange={handleAccordionChange1('panel17')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                            >
                            <Typography sx={classes.heading}>Problem2 </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                        <GridContainer>
                            <GridItem xs={12} sm={12} md={6}>
                            <blockquote className="blockquote">
                            <p> After repairing the bridge you have reached the damaged ship which needs to be repaired using aluminium sheets.</p> 
                            <p> First you need to find the total number of holes that needs to be repaired. Your team is observing the boat and analyzing the cracks(holes) in the ship that needs to be repaired to stop the oil spilling.</p> 
                            <p> After observing the holes, it was found that total 10 holes of different surface areas needs to be repaired.</p> 
                            <p> The area of first hole is 24, second hole is 12, third hole is 15, fourth hole is 20 and so on upto 10 holes with area {'{'}24, 12, 15, 20, 49, 29, 13, 18, 25, 30{'}'}. </p>
                            <p> You have a machine to cut aluminium sheets that can be used to cover the holes. So, you want to create aluminium sheets that have size equal to maximum pairs to cover all holes.</p>     
                            <p> Your task is to find the pairs having maximum surface area from the given set S = {'{'}24, 12, 15, 20, 49, 29, 13, 18, 25, 30{'}'} to repair the boat.</p> 
                            <p> You need find a method to find maximum of pairwise sum. You cannot calculate manually as it may take lot of time, so you decided to write an algorithm to find pair of area of holes for maximum area. Your objective is defined as follows:</p>
                            <p> Pair of holes with maximum area=maximum sum pair among numbers {'{'}24, 12, 15, 20, 49, 29, 13, 18, 25, 30{'}'}</p>
                            </blockquote>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={6}>
                            <img alt='Activity1Medium' className="card-img-top"  src={baseUrl+'assets/images/act6-maxPairSum.PNG'} />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                            <blockquote className="blockquote">
                                <p><strong>Input: </strong>A set of numbers {'{'}24, 12, 15, 20, 49, 29, 13, 18, 25, 30{'}'}</p><p><strong>Output: </strong>pair with maximum sum = 49,30 </p><p><strong>Objective: </strong> Given the sizes of holes in ship {'{'}24, 12, 15, 20, 49, 29, 13, 18, 25, 30{'}'}. Design an algorithm to identify two holes which adds up to maximum value. Find pairs with maximum sum of holes</p>
                            </blockquote>
                            </GridItem>
                        </GridContainer>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded1 === 'panel18'} onChange={handleAccordionChange1('panel18')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                            >
                            <Typography sx={classes.heading}>Problem3 </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <GridItem xs={12} sm={6} md={12}>
                                <Card sx={{    border: '2px solid grey'}}>
                                    <CardHeader color="info">
                                        <h4 style={classes1.cardTitleWhite}> Problem3</h4>
                                    </CardHeader>
                                    <CardBody>
                                    <GridContainer>
                                        <GridItem xs={12} sm={12} md={6}>
                                        <blockquote className="blockquote">
                                        <p> The captain gave you a brief idea regarding the overall damage to the ship. Your team is observing the boat and analyzing the cracks(holes) in the ship that needs to be repaired. </p>
                                        <p> After observing the holes, it was found that total 6 holes of different surface areas needs to be repaired. </p> 
                                        <p> The area of first hole is 24, second hole is 12, third hole is 15, fourth hole is 20 and so on upto 10 holes with area {'{'}24, 12, 25, 20, 49, 32{'}'}.</p> 
                                        <p> You decided to create two teams to repair the holes. Each team will repair equal areas of holes. </p> 
                                        <p> Thus you decided to divide the 6 element array into two sub array such that sum in each array is same. </p> 
                                        <p> Your task is to split the given set of numbers S = {'{'}24, 12, 25, 20, 49, 32 {'}'} into two set of numbers (arrays) with equal sum.</p>              
                                        <p> You cannot calculate manually as it may take lot of time, so you decided to write an algorithm to find equal sum subarray. Your objective is defined as follows: </p>
                                        </blockquote>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={6}>
                                        <img alt='Activity1Medium' className="card-img-top"  src={baseUrl+'assets/images/act6-equalsumArray.PNG'} />
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={12}>
                                        <blockquote className="blockquote">
                                            <p>Subarray with equal sum= Two equal subarrays among {'{'} 24, 12, 25, 20, 49, 32 {'}'}</p>
                                            <p><strong>Input: </strong>A set of numbers {'{'}24, 12, 25, 20, 49, 32{'}'}</p><p><strong>Output: </strong>Equal sum among subarray=81 </p><p><strong>Objective: </strong> Given the sizes of holes in ship {'{'}24, 12, 25, 20, 49, 32{'}'}. Design an algorithm to divide the set of numbers ={'{'}24, 12, 25, 20, 49, 32{'}'} into two set of numbers having equal sum.</p>
                                        </blockquote>
                                        </GridItem>
                                    </GridContainer>
                                    </CardBody>
                                </Card>
                            </GridItem>
                        </AccordionDetails>
                    </Accordion>
                </GridContainer>
                
                </CardBody>
            </Card>
        </GridContainer>:<p>This is some problem / Please Login again</p> }

      {/* <div className="container">
          <div className="px-0 col-lg-8 col-md-10 col-sm-12 mx-auto text-center">
              <p className="font-size-lg text-black-100">
                    Inactive classes
              </p>
          </div>
      </div> */}


    </div>:<GridContainer spacing={3}>
        <GridItem xs={12} sm={12} md={4}>
        </GridItem>
        <GridItem xs={12} sm={12} md={4}>
          <Skeleton variant="text" /> 
          <Skeleton variant="text" /> 
        </GridItem>
        <GridItem xs={12} sm={12} md={4}>
        </GridItem>
        <GridItem xs={12} sm={12} md={4}>
          <Box sx={{ width: 420, marginRight: 2, my: 5, padding: 2 }}>
            <Skeleton animation="wave" variant="rectangular" width={420} height={300} />    
          </Box>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
          <Box sx={{ width: 420, marginRight: 2, my: 5 }}>
            <Skeleton animation="wave" variant="rectangular" width={420} height={300} />    
          </Box> 
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
          <Box sx={{ width: 420, marginRight: 2, my: 5 }}>
            <Skeleton variant="circular" width={420} height={300} />    
          </Box> 
        </GridItem>
        <GridItem xs={12} sm={12} md={4}>
        </GridItem>
        <GridItem xs={12} sm={12} md={4}>
          <Skeleton variant="text" /> 
        </GridItem>  
      </GridContainer>
  );
}
